import { render } from "./CHECKBOX.vue?vue&type=template&id=6d00492e&scoped=true"
import script from "./CHECKBOX.vue?vue&type=script&lang=js"
export * from "./CHECKBOX.vue?vue&type=script&lang=js"

import "./CHECKBOX.vue?vue&type=style&index=0&id=6d00492e&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d00492e"]])

export default __exports__